
import {map, catchError} from 'rxjs/operators';
import {Injectable} from "@angular/core";

import { ActivatedRouteSnapshot } from "@angular/router";
import {Observable, Subject, BehaviorSubject, of} from "rxjs";
import {Client, ClientService} from "../../../../swaggerServices";

@Injectable()
export class ClientRouteResolver {
  curClient: Client;
  subject: Subject<Client | null> = new BehaviorSubject(null);

  constructor(private clientService: ClientService) {
  }

  resolve(route: ActivatedRouteSnapshot) {
    const clientId = Number(route.paramMap.get('clientId'));
    const taxYear = route.queryParams.taxYear ? String(route.queryParams.taxYear) : undefined;
    return this.resolveForClient(clientId, taxYear);
  }

  resolveForClient(clientId: number, year?: string) {
    const yearInt = year? +year :undefined
    return this.clientService.getClientById(clientId, yearInt).pipe(
      catchError(() => of(null)),
      map(client => {
        this.curClient = client;
        this.subject.next(client);
        return client;
      }),);

  }

  client(): Observable<Client> {
    return this.subject;
  }

}
